import { useState, useEffect } from 'react';
import { api } from '../lib/api-client';

export interface Section {
  id: string;
  app: string;
  title: string;
  description: string | null;
  icon: string;
  sort_order: number;
  is_active: boolean;
  topic_count: number;
  total_topic_count: number;
}

export interface SectionsData {
  main: Section[];
  'health-insurance': Section[];
}

export function useSections() {
  const [sections, setSections] = useState<SectionsData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function fetchSections() {
      try {
        const data = await api.getSections();
        if (!cancelled) {
          setSections(data.sections);
          setLoading(false);
        }
      } catch (err: any) {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      }
    }

    fetchSections();
    return () => { cancelled = true; };
  }, []);

  return { sections, loading, error };
}
